webpackJsonp([155779750228925],{

/***/ 1941:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PrintLabelResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"status","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-print-label-result-cfc039c9d5fd28935052.js